import { colors, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const AssigneesBlockStyled = styled.div`
  padding-right: 0.5rem;
  white-space: pre-wrap;
`;

export const AssigneeNameStyled = styled.span`
  display: block;

  &:last-of-type {
    display: inline;
  }
`;

export const HideButtonStyled = styled.button`
  display: inline-block;
  background-color: ${colors.blue[100]};
  border: none;
  color: ${colors.neutral[500]};
  padding: 0 0.9rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  ${typography.regular[12]};
  cursor: pointer;
`;
